import axios from 'axios';

// Tüm istekler için ortak Base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://26.24.69.128:5000/api';

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Request Interceptor: Her isteğe Token ekle
apiClient.interceptors.request.use(
    (config) => {
        if (config.headers['Authorization']) return config;

        const userStr = localStorage.getItem('user');
        if (userStr) {
            const user = JSON.parse(userStr);
            if (user.token) {
                config.headers['Authorization'] = `Bearer ${user.token}`;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor: 401 Hatalarını Yakala (Token Süresi Dolduysa veya Yoksa)
apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

const api = {
    // --- Deliveries (Teslimatlar) ---
    getDeliveries: (params) => apiClient.get('/deliveries', { params }),
    createDelivery: (data) => apiClient.post('/deliveries', data),
    updateDeliveryStatus: (id, status) => apiClient.put(`/deliveries/${id}/status`, { status }),

    // --- Investments (Yatırımlar / Admin Requests) ---
    getInvestments: (params) => apiClient.get('/admin/requests', { params }),
    createInvestment: (data) => apiClient.post('/admin/requests', data),
    updateInvestmentStatus: (id, data) => apiClient.put(`/admin/requests/${id}/status`, data),
    updateInvestmentAmount: (id, data) => apiClient.put(`/admin/requests/${id}/amount`, data),
    deleteInvestment: (id) => apiClient.delete(`/admin/requests/${id}`),
    moveInvestment: (id, panelId) => apiClient.put(`/admin/requests/${id}/move`, { panelId }),

    // --- Withdrawals (Çekimler) ---
    getWithdrawals: (params) => apiClient.get('/withdrawals', { params }),
    createAdminWithdrawal: (data) => apiClient.post('/admin/withdrawals', data),
    updateWithdrawalStatus: (id, status, extra = {}) => apiClient.put(`/withdrawals/${id}/status`, { status, ...extra }),
    deleteWithdrawal: (id) => apiClient.delete(`/withdrawals/${id}`),
    forwardWithdrawal: (id, panelId) => apiClient.put(`/withdrawals/${id}/forward`, { panelId }),
    uploadReceipt: (id, data) => apiClient.post(`/withdrawals/${id}/receipt`, data),
    getReceipt: (id) => apiClient.get(`/withdrawals/${id}/receipt`),

    // --- Panels (Paneller) ---
    getPanels: () => apiClient.get('/panels'),
    createPanel: (data) => apiClient.post('/panels', data),
    updatePanel: (id, data) => apiClient.put(`/panels/${id}`, data),
    deletePanel: (id) => apiClient.delete(`/panels/${id}`),
    resetKasa: (id) => apiClient.post(`/panels/${id}/reset-kasa`),
    getPanelKasaDaily: (params) => apiClient.get('/panel-kasa-daily', { params }),
    snapshotPanelKasa: () => apiClient.post('/panel-kasa-daily/snapshot'),
    getMutabakat: (panelId) => apiClient.get(`/panels/${panelId}/mutabakat`),

    // --- Accounts (Hesaplar) ---
    getAccounts: (params) => apiClient.get('/account-definitions', { params }),
    createAccount: (data) => apiClient.post('/account-definitions', data),
    updateAccount: (id, data) => apiClient.put(`/account-definitions/${id}`, data),
    deleteAccount: (id) => apiClient.delete(`/account-definitions/${id}`),

    // --- Users (Kullanıcılar) ---
    getUsers: (params) => apiClient.get('/users', { params }),
    createUser: (data) => apiClient.post('/users', data),
    updateUser: (id, data) => apiClient.put(`/users/${id}`, data),
    deleteUser: (id) => apiClient.delete(`/users/${id}`),
    setup2FA: (id) => apiClient.post(`/users/${id}/2fa/setup`),
    verify2FA: (id, data) => apiClient.post(`/users/${id}/2fa/verify`, data),
    disable2FA: (id) => apiClient.post(`/users/${id}/2fa/disable`),

    // --- Yönetim Kullanıcıları (roller) ---
    getManagementUsers: () => apiClient.get('/management-users'),
    createManagementUser: (data) => apiClient.post('/management-users', data),
    updateManagementUser: (id, data) => apiClient.put(`/management-users/${id}`, data),
    deleteManagementUser: (id) => apiClient.delete(`/management-users/${id}`),

    // --- Blacklist (Kara Liste) ---
    getBlacklist: (params) => apiClient.get('/blacklist', { params }),
    addToBlacklist: (data) => apiClient.post('/blacklist', data),
    removeFromBlacklist: (id) => apiClient.delete(`/blacklist/${id}`),

    // --- Banks (Bankalar) ---
    getBanks: () => apiClient.get('/banks'),

    // --- Logs (Loglar) ---
    getLogs: (params) => apiClient.get('/logs', { params }),
    createLog: (data) => apiClient.post('/logs', data),
    getApiLogs: () => apiClient.get('/api-logs'),

    // --- External (Dış Servisler) ---
    getUsdtRate: () => axios.get('https://api.binance.com/api/v3/ticker/price?symbol=USDTTRY'),

    // --- Public (Landing Page) ---
    getOptions: () => apiClient.get('/options'),
    createRequest: (data) => apiClient.post('/requests', data),

    // --- Auth ---
    login: (data) => apiClient.post('/login', data),

    // --- API Keys ---
    getApiKeys: () => apiClient.get('/api-keys'),
    createApiKey: (data) => apiClient.post('/api-keys', data),
    updateApiKey: (id, data) => apiClient.patch(`/api-keys/${id}`, data),
    deleteApiKey: (id) => apiClient.delete(`/api-keys/${id}`),

    // --- Partner ---
    partnerLogin: (data) => apiClient.post('/auth/partner-login', data),
    getPartnerStats: (headers) => apiClient.get('/partner/my-stats', { headers }),
    getPartnerTransactions: (params, headers) => apiClient.get('/partner/transactions', { params, headers }),

    // --- Partner Management (Admin) ---
    getPartners: () => apiClient.get('/partners'),
    createPartner: (data) => apiClient.post('/partners', data),
    updatePartner: (id, data) => apiClient.patch(`/partners/${id}`, data),
    deletePartner: (id) => apiClient.delete(`/partners/${id}`),

    // --- Accounting (Muhasebe) ---
    getFirmAccounting: (params) => apiClient.get('/accounting/firms', { params }),
    getFirmPanelMap: () => apiClient.get('/firm-panel-map'),

    // --- System ---
    getArchivedData: () => apiClient.get('/admin/archive-data'),
};

export default api;